import { getResourceFromCms } from '@namespace/helpers';

export const getSeoConfigFromCMS = (route, options) =>
  getResourceFromCms(`/seoBatch${route}`, options).catch(() => ({
    data: {}
  }));
